import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { devicesAPI } from '../../api/client';
import C from '../../theme';
import { ColorBtn, StatusPill, BattBar, CopyBtn, SecCode } from '../../components/UI';

const lbl={fontSize:13,fontWeight:600,color:C.textSec,display:'block',marginBottom:6};
const inp={width:'100%',padding:'10px 14px',background:'#fff',border:`1px solid ${C.border}`,borderRadius:8,fontSize:14,fontFamily:C.font,fontWeight:500,color:C.text,outline:'none',boxSizing:'border-box'};
const td={padding:'12px 14px',fontSize:13,borderBottom:`1px solid ${C.borderLight}`};

function AddModal({open,onClose,onSuccess}){
  const[imei,setImei]=useState('');const[model,setModel]=useState('GF-22');const[desc,setDesc]=useState('');
  const[loading,setLoading]=useState(false);const[error,setError]=useState({});const[created,setCreated]=useState(null);
  const reset=()=>{setImei('');setModel('GF-22');setDesc('');setError({});setCreated(null);};
  const handleClose=()=>{if(created)onSuccess();reset();onClose();};
  const handleSubmit=async(e)=>{e.preventDefault();setError({});setLoading(true);
    try{const r=await devicesAPI.create({imei,model_name:model,description:desc});setCreated(r.data);}
    catch(err){setError(err.response?.data||{general:'Xatolik'});}setLoading(false);};
  if(!open)return null;

  return <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.3)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200,padding:20}} onClick={handleClose}>
    <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:440,maxHeight:'90vh',overflow:'auto',boxShadow:C.shadowModal}} onClick={e=>e.stopPropagation()}>
      <div style={{padding:'20px 20px 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <h2 style={{fontSize:18,fontWeight:700,color:C.text,margin:0}}>{created?'✅ Qurilma yaratildi':'Yangi qurilma'}</h2>
        <button onClick={handleClose} style={{background:'#F1F5F9',border:'none',borderRadius:8,width:32,height:32,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',color:C.textMuted,fontSize:16}}>✕</button>
      </div>
      <div style={{padding:20}}>
        {created?<div>
          <div style={{background:C.blueSoft,border:`1px solid ${C.blueBorder}`,borderRadius:10,padding:20,textAlign:'center',marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:C.textMuted,letterSpacing:1,marginBottom:6}}>IMEI</div>
            <div style={{fontFamily:C.mono,fontSize:16,fontWeight:600,color:C.text,letterSpacing:2,marginBottom:16}}>{created.imei} <CopyBtn text={created.imei}/></div>
            <div style={{background:'#fff',borderRadius:8,padding:16,border:`1px solid ${C.blueBorder}`}}>
              <div style={{fontSize:11,fontWeight:700,color:C.blue,letterSpacing:1,marginBottom:6}}>🔑 HIMOYA KODI</div>
              <div style={{fontFamily:C.mono,fontSize:28,fontWeight:700,color:C.blue,letterSpacing:5}}>{created.security_code}</div>
              <div style={{marginTop:10}}><CopyBtn text={created.security_code}/></div>
            </div>
          </div>
          <div style={{background:C.yellowSoft,border:'1px solid #FCD34D',borderRadius:8,padding:'12px 14px',marginBottom:16,fontSize:13,color:'#92400E',fontWeight:500}}>
            ⚠️ Bu kodni yozib oling! Ota-ona IMEI + Himoya kodi orqali biriktiradi.
          </div>
          <ColorBtn onClick={handleClose} color={C.green} style={{width:'100%',borderRadius:8}}>Tayyor</ColorBtn>
        </div>:
        <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:16}}>
          {(error.general||error.non_field_errors)&&<div style={{background:C.coralSoft,color:'#DC2626',padding:'10px 14px',borderRadius:8,fontSize:13,fontWeight:600,border:'1px solid #FCA5A5'}}>⚠️ {error.general||error.non_field_errors}</div>}
          <div><label style={lbl}>IMEI raqami</label>
            <div style={{position:'relative'}}><input style={{...inp,fontFamily:C.mono,letterSpacing:2}} value={imei} onChange={e=>{setImei(e.target.value.replace(/\D/g,'').slice(0,15));setError({});}} placeholder="000000000000000" maxLength={15} autoFocus/>
              <span style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',fontSize:12,fontWeight:600,fontFamily:C.mono,color:imei.length===15?C.green:C.textMuted}}>{imei.length}/15</span></div>
            {error.imei&&<div style={{fontSize:12,color:'#DC2626',marginTop:4}}>{error.imei}</div>}</div>
          <div><label style={lbl}>Model</label>
            <select style={{...inp,cursor:'pointer'}} value={model} onChange={e=>setModel(e.target.value)}>
              <option value="GF-22">GF-22 Mini Tracker</option><option value="GF-21">GF-21</option><option value="GT06">GT06</option><option value="TK102">TK102</option></select></div>
          <div><label style={lbl}>Izoh (ixtiyoriy)</label>
            <input style={inp} value={desc} onChange={e=>setDesc(e.target.value)} placeholder="Masalan: Partiya #3"/></div>
          <div style={{background:C.blueSoft,borderRadius:8,padding:'10px 14px',fontSize:13,color:C.blue,fontWeight:500,border:`1px solid ${C.blueBorder}`}}>
            🛡 Himoya kodi avtomatik generatsiya qilinadi
          </div>
          <div style={{display:'flex',gap:10}}>
            <button type="button" onClick={handleClose} style={{flex:1,padding:'10px',background:'#F1F5F9',border:`1px solid ${C.border}`,borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer',color:C.textSec,fontFamily:C.font}}>Bekor</button>
            <ColorBtn disabled={imei.length!==15||loading} style={{flex:2,borderRadius:8}}>{loading?'Saqlanmoqda...':'Qo\'shish ＋'}</ColorBtn>
          </div>
        </form>}
      </div>
    </div>
  </div>;
}

function DetailModal({device:d,open,onClose,onDelete,onRegenerate}){
  const[cd,setCd]=useState(false);const[dl,setDl]=useState(false);
  if(!open||!d)return null;
  const handleDel=async()=>{setDl(true);await onDelete(d.id);setDl(false);setCd(false);onClose();};
  const handleRegen=async()=>{await onRegenerate(d.id);};
  return <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.3)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200,padding:20}} onClick={onClose}>
    <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:480,maxHeight:'90vh',overflow:'auto',boxShadow:C.shadowModal}} onClick={e=>e.stopPropagation()}>
      <div style={{padding:'20px 20px 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:24}}>📡</span>
          <div><h2 style={{fontSize:18,fontWeight:700,color:C.text,margin:0}}>{d.model_name}</h2><p style={{fontFamily:C.mono,fontSize:12,color:C.textMuted,margin:0}}>{d.imei}</p></div>
        </div>
        <button onClick={onClose} style={{background:'#F1F5F9',border:'none',borderRadius:8,width:32,height:32,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',color:C.textMuted,fontSize:16}}>✕</button>
      </div>
      <div style={{padding:20}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
          {[
            {l:'Holat',v:<StatusPill status={d.status}/>},
            {l:'Batareya',v:<BattBar level={d.battery_level}/>},
            {l:'Egasi',v:<span style={{fontWeight:600,fontSize:14}}>{d.owner_name||'—'}</span>},
            {l:'Sana',v:<span style={{fontFamily:C.mono,fontSize:13}}>{new Date(d.created_at).toLocaleDateString('uz-UZ')}</span>},
          ].map((r,i)=>
            <div key={i} style={{background:'#F8FAFC',borderRadius:8,padding:'12px 14px',border:`1px solid ${C.borderLight}`}}>
              <div style={{fontSize:11,fontWeight:600,color:C.textMuted,letterSpacing:1,marginBottom:6}}>{r.l.toUpperCase()}</div>
              {r.v}
            </div>
          )}
        </div>
        <div style={{background:C.blueSoft,borderRadius:8,padding:'16px',textAlign:'center',marginBottom:16,border:`1px solid ${C.blueBorder}`}}>
          <div style={{fontSize:11,fontWeight:600,color:C.textMuted,letterSpacing:1,marginBottom:8}}>🔑 HIMOYA KODI</div>
          <SecCode code={d.security_code} big/>
          <div style={{marginTop:12}}>
            <button onClick={handleRegen} style={{background:C.blue,color:'#fff',border:'none',borderRadius:6,padding:'6px 16px',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:C.font}}>🔄 Yangilash</button>
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
          {!cd?<button onClick={()=>setCd(true)} style={{background:C.coralSoft,color:'#DC2626',border:'1px solid #FCA5A5',borderRadius:8,padding:'8px 16px',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:C.font}}>🗑 O'chirish</button>
          :<div style={{display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:13,color:'#DC2626',fontWeight:600}}>Ishonchingiz komilmi?</span>
            <ColorBtn onClick={handleDel} disabled={dl} color="#DC2626" style={{fontSize:13,padding:'8px 16px',borderRadius:8}}>{dl?'...':'Ha'}</ColorBtn>
            <button onClick={()=>setCd(false)} style={{padding:'8px 16px',background:'#F1F5F9',color:C.textSec,border:`1px solid ${C.border}`,borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:C.font}}>Yo'q</button>
          </div>}
        </div>
      </div>
    </div>
  </div>;
}

export default function DevicesPage(){
  const[devices,setDevices]=useState([]);const[loading,setLoading]=useState(true);
  const[search,setSearch]=useState('');const[filter,setFilter]=useState('');
  const[showAdd,setShowAdd]=useState(false);const[sel,setSel]=useState(null);const[hov,setHov]=useState(null);
  const[searchParams]=useSearchParams();

  const fetchDevices=useCallback(async()=>{
    setLoading(true);
    try{const p={};if(search)p.search=search;if(filter)p.status=filter;const r=await devicesAPI.list(p);setDevices(r.data.results||r.data);}catch{}
    setLoading(false);
  },[search,filter]);

  useEffect(()=>{fetchDevices();},[fetchDevices]);
  useEffect(()=>{if(searchParams.get('action')==='add')setShowAdd(true);},[searchParams]);

  const handleDelete=async(id)=>{await devicesAPI.delete(id);fetchDevices();};
  const handleRegenerate=async(id)=>{const r=await devicesAPI.regenerateCode(id);setSel(r.data);fetchDevices();};

  return <div>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20,flexWrap:'wrap',gap:12}}>
      <div><h1 style={{fontSize:20,fontWeight:700,color:C.text,margin:0}}>📡 Qurilmalar</h1><p style={{fontSize:13,color:C.textMuted,margin:'4px 0 0'}}>Jami {devices.length} ta qurilma</p></div>
      <button onClick={()=>setShowAdd(true)} style={{padding:'10px 20px',background:C.blue,color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:C.font}}>＋ Yangi qurilma</button>
    </div>

    <div style={{display:'flex',gap:10,marginBottom:16,flexWrap:'wrap'}}>
      <div style={{position:'relative',flex:1,minWidth:200}}>
        <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',fontSize:14}}>🔍</span>
        <input style={{...inp,paddingLeft:36}} placeholder="IMEI qidirish..." value={search} onChange={e=>setSearch(e.target.value)}/>
      </div>
      <div style={{display:'flex',gap:6}}>
        {[
          {v:'',l:'Barchasi'},
          {v:'new',l:'Yangi',c:'#92400E',bg:C.yellowSoft,bc:'#FCD34D'},
          {v:'active',l:'Faol',c:'#065F46',bg:C.greenSoft,bc:'#6EE7B7'},
          {v:'inactive',l:'Nofaol',c:'#991B1B',bg:C.coralSoft,bc:'#FCA5A5'},
        ].map(f=>{
          const act=filter===f.v||(f.v===''&&!filter);
          return <button key={f.v} onClick={()=>setFilter(f.v)} style={{
            padding:'8px 14px',
            background: act ? (f.bg||C.blueSoft) : '#fff',
            border: `1px solid ${act ? (f.bc||C.blueBorder) : C.border}`,
            borderRadius:8, fontSize:13, fontWeight:act?600:500,
            color: act ? (f.c||C.blue) : C.textSec,
            cursor:'pointer', fontFamily:C.font,
          }}>{f.l}</button>;
        })}
      </div>
    </div>

    <div style={{background:'#fff',borderRadius:12,border:`1px solid ${C.border}`,overflow:'hidden'}}>
      {loading?<div style={{textAlign:'center',padding:'40px',color:C.textMuted}}>Yuklanmoqda...</div>
      :devices.length===0?<div style={{textAlign:'center',padding:'48px'}}><div style={{fontSize:40,marginBottom:12,opacity:0.3}}>📡</div><p style={{fontWeight:600,color:C.text,fontSize:16}}>Qurilmalar topilmadi</p></div>
      :<div style={{overflowX:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead><tr>{['#','IMEI','Model','Himoya kodi','Holat','Egasi','Batareya','Sana'].map((h,i)=><th key={i} style={{textAlign:'left',padding:'10px 14px',fontSize:11,fontWeight:600,color:C.textMuted,letterSpacing:0.5,borderBottom:`1px solid ${C.border}`,background:'#F8FAFC'}}>{h}</th>)}</tr></thead>
          <tbody>{devices.map((d,i)=><tr key={d.id} onClick={()=>setSel(d)} onMouseEnter={()=>setHov(d.id)} onMouseLeave={()=>setHov(null)} style={{cursor:'pointer',background:hov===d.id?'#F8FAFC':'transparent',transition:'background 0.1s'}}>
            <td style={td}><span style={{color:C.textMuted,fontWeight:600,fontSize:12}}>{i+1}</span></td>
            <td style={td}><code style={{fontFamily:C.mono,fontSize:13,fontWeight:500,background:'#F1F5F9',padding:'4px 8px',borderRadius:4,color:C.text,letterSpacing:1}}>{d.imei}</code></td>
            <td style={td}><span style={{padding:'3px 10px',background:C.blueSoft,borderRadius:4,fontSize:13,fontWeight:600,color:C.blue,border:`1px solid ${C.blueBorder}`}}>{d.model_name}</span></td>
            <td style={td}><SecCode code={d.security_code}/></td>
            <td style={td}><StatusPill status={d.status}/></td>
            <td style={td}>{d.owner_name?<span style={{fontSize:13,fontWeight:600}}>{d.owner_name}</span>:<span style={{color:C.textMuted}}>—</span>}</td>
            <td style={td}><BattBar level={d.battery_level}/></td>
            <td style={td}><span style={{fontSize:12,color:C.textSec,fontFamily:C.mono}}>{new Date(d.created_at).toLocaleDateString('uz-UZ')}</span></td>
          </tr>)}</tbody>
        </table>
      </div>}
    </div>

    <AddModal open={showAdd} onClose={()=>setShowAdd(false)} onSuccess={fetchDevices}/>
    <DetailModal device={sel} open={!!sel} onClose={()=>setSel(null)} onDelete={handleDelete} onRegenerate={handleRegenerate}/>
  </div>;
}
